import { Stack, styled } from '@mui/material';

export const PhoneInputContainer = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== 'callingCode' && prop !== 'hasError' && prop !== 'isValid' && prop !== 'isDisabled',
})<{ callingCode: string; hasError: boolean; isValid: boolean; isDisabled?: boolean }>(
  ({ callingCode, hasError, isValid, isDisabled }) => ({
    marginBottom: hasError || !isValid ? 0 : '1rem',
    '--calling-code': `"+${callingCode}"`,

    '& .PhoneInput': {
      display: 'flex',
      gap: '0.25rem',
      alignItems: 'stretch',
    },

    '& .PhoneInputCountry': {
      height: '40px',
      border: isDisabled ? '1px solid #DBDBE2' : '1px solid rgba(0, 0, 0, 0.15)',
      borderRadius: '0.5rem',
      backgroundColor: isDisabled ? '#fafafa' : '#FFFFFF',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      '& *': {
        cursor: isDisabled ? 'not-allowed !important' : undefined,
      },
      padding: '0 12px',
      display: 'flex',
      alignItems: 'center',
      transition: 'all 0.2s',
      minWidth: 'fit-content',
      boxSizing: 'border-box',

      '&::after': {
        content: 'var(--calling-code)',
        fontSize: '0.75rem',
        fontWeight: 500,
        color: isDisabled ? '#A4A4B6' : '#615E6F',
        marginLeft: '6px',
      },

      ...(!isDisabled && {
        '&:hover': {
          borderColor: 'black',
        },
      }),
      '&:focus-within': {
        borderColor: '#4592fa',
        boxShadow: '0 0 0 1px #4592fa',
      },
    },

    '& .PhoneInputInput': {
      height: '40px',
      border: isDisabled ? '1px solid #DBDBE2' : '1px solid rgba(0, 0, 0, 0.15)',
      borderRadius: '0.75rem',
      padding: '0.75rem 1rem',
      width: '100%',
      outline: 'none',
      transition: 'all 0.2s',
      color: isDisabled ? '#A4A4B6' : '#615E6F',
      WebkitTextFillColor: isDisabled ? '#A4A4B6' : '#615E6F',
      cursor: isDisabled ? 'not-allowed' : 'text',
      fontWeight: 500,
      fontSize: '0.75rem',
      boxSizing: 'border-box',
      backgroundColor: isDisabled ? '#fafafa' : '#FFFFFF',

      '&::placeholder': {
        color: '#A4A4B6',
        opacity: 1,
      },

      ...(!isDisabled && {
        '&:hover': {
          borderColor: 'black',
        },
      }),
      '&:focus': {
        borderColor: '#4592fa',
        boxShadow: '0 0 0 1px #4592fa',
      },
    },

    '& .PhoneInputCountrySelectArrow': {
      display: 'none',
    },

    '& .PhoneInputCountryIcon': {
      boxShadow: 'none',
      height: 'auto',
      width: '24px',
      borderRadius: '4px',
      overflow: 'hidden',
      display: 'block',
    },

    '& .PhoneInputCountryIconImg': {
      borderRadius: '4px',
      display: 'block',
    },
  }),
);
